import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { RegisterPage } from '@lemsar/auth/views/pages/register.page';
import { AuthenticatedGuard } from '@naker/naco';
import { SignOutPage } from '@lemsar/auth/views/pages/sign-out.page';
import { UnregisteredGuard } from '@lemsar/auth/guards/unregistered.guard';
import { ActivationPage } from '@lemsar/auth/views/pages/activation.page';
import { RegisterContainer } from '@lemsar/auth/views/containers/register.container';

const routes: Routes = [
    {
        path: 'auth',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'register',
            },
            {
                path: 'register',
                canActivate: [AuthenticatedGuard, UnregisteredGuard],
                component: RegisterPage,
                children: [
                    {
                        path: ':type',
                        component: RegisterContainer,
                    },
                    {
                        path: '',
                        redirectTo: 'landing',
                        pathMatch: 'full',
                    },
                ],
            },
            {
                path: 'logout',
                component: SignOutPage,
            },
        ],
    },
    {
        path: 'activate/:code',
        component: ActivationPage,
        canActivate: [AuthenticatedGuard, UnregisteredGuard],
    },
];

export const AUTH_ROUTING: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/lemsar/auth/auth.routes.ts